import FieldProto from "../../../proto/field-proto"

import FieldConfig from "../../../proto/field-config";

export default class FieldEventType extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Event type"
        this.label      = "Event type"
    }

    /*** DATA FUNCTIONS ***/

    getDisplayValue(value:any) {
        return gd.const.event[value].name
    }

    // _getValue(value:string) {
    //     return gd.const.event[value].name
    // }
    //

}